import { render, staticRenderFns } from "./Item20.vue?vue&type=template&id=86ab43a0&scoped=true&"
import script from "./Item20.vue?vue&type=script&lang=js&"
export * from "./Item20.vue?vue&type=script&lang=js&"
import style0 from "./Item20.vue?vue&type=style&index=0&id=86ab43a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ab43a0",
  null
  
)

export default component.exports